import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import "whatwg-fetch"

import BlogSettings from "../components/setting/blog/BlogSettings"

import { jsonResponseHandler } from '../utils/FetchHelper'
import { receiveSettings } from '../actions/setting/blog'
import * as InitStatus from '../constants/common/InitializationStatus';
import {addPrefix} from "../utils/UriUtil";


export default function BlogSettingApp() {
  const currentUserRole = useSelector(state => state.user.role)
  const dispatch = useDispatch()
  const [initialized, setInitialized] = useState(InitStatus.INIT_READY)

  function init() {
    setInitialized(InitStatus.INIT_DOING)
    fetch(addPrefix("/manage/setting/blog.json"), {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        dispatch(receiveSettings(data))
        setInitialized(InitStatus.INIT_SUCCESS)
      })
      .catch(e => {
        console.error(e);
        setInitialized(InitStatus.INIT_FAIL)
      })
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <div className="inner_article manage_article">
      <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
      <BlogSettings
        initialized={initialized}
        role={currentUserRole}
        onRetryInit={init}
      />
    </div>
  )
}
